// removed by extract-text-webpack-plugin
module.exports = {"user-container":"UserContainer__user-container___t1UpJ"};